import React, { FC, useState } from 'react';
import { Row, Col } from 'styled-bootstrap-grid';
import Cookie from 'js-cookie';

import { useTranslations } from '@lang';
import SignInForm from '@features/SignIn/pages/SignIn/components/SignInForm';
import { Link, useRouter, Router } from 'shared-routing';
import { Routes } from '@common/constants';

import { Button } from '@common/components/Button';
import {
  Background,
  Content,
  Heading,
  SectionContainer,
} from '@common/components/AuthLayout/Layout';
import { useSignInSession } from '@features/SignIn/hooks/useSignInSession';
import { SignInProps, SignInReduxProps } from './SignIn.types';
import { ForgottenPasswordLink, SectionCTA } from './SignIn.styles';

export const SignIn: FC<SignInProps & SignInReduxProps> = ({
  homepage,
  propertyId,
  language,
  signIn,
  fetchBasketDetails,
}) => {
  const { t } = useTranslations();
  const router = useRouter();
  const [loginError, setLoginError] = useState('');
  useSignInSession();

  const handleSignIn = async (data) => {
    try {
      await signIn(propertyId, data);
    } catch (e) {
      setLoginError('invalidLogin');
      return;
    }

    const redirectTo = router.query.redirectTo?.toString();
    const basketId = Cookie.get('basketId');

    try {
      if (basketId) {
        await fetchBasketDetails(propertyId, basketId, language);
      }
    } catch (e) {}

    await Router.push(redirectTo || Routes.HOME);
  };

  return (
    <SectionContainer>
      <Background src={homepage?.heroBackgroundImage?.url} />
      <Content>
        <Heading>{t('signIn.header')}</Heading>
        <SignInForm onSubmit={handleSignIn} loginError={loginError} />
        <Link route={Routes.FORGOTTEN_PASSWORD}>
          <ForgottenPasswordLink>{t('register.forgottenPassword')}</ForgottenPasswordLink>
        </Link>
        <SectionCTA>
          <Row alignItems="center">
            <Col col xs={12} sm={12} lg={4}>
              <Heading>{t('signIn.registerCTA')}</Heading>
            </Col>
            <Col col xs={12} sm={12} lg={4}>
              <Link route={Routes.REGISTER}>
                <Button type="button">{t('signIn.goToRegister')}</Button>
              </Link>
            </Col>
          </Row>
        </SectionCTA>
      </Content>
    </SectionContainer>
  );
};
